import { Api } from "../Api/Api";

export const registerUserApi = (data) => Api.post(`api/userRegister`, data);

export const removeUserApi = (user_id) => Api.delete(`api/deleteUser?user_id=${user_id}`);

export const editGroupApi = (data) => Api.put("api/editGroupProfile", data);

export const userNotificationApi =()=> Api.get("api/get_notification_message");
